import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import { Guest, Authenticated, middlewarePipeline } from './middleware'

Vue.use(VueRouter)

const routes = [
  {
    path: '/auth',
    name: 'auth',
    redirect: { name: 'auth.signin' },
    component: () => import('../layouts/auth'),
    meta: {
      middleware: [Guest]
    },
    children: [
      {
        name: 'auth.signin',
        path: 'signin',
        component: () => import('../views/auth/SignIn'),
        meta: {
          title: 'Sign In'
        }
      },
      {
        name: 'auth.signup',
        path: 'signup',
        component: () => import('../views/auth/SignUp'),
        meta: {
          title: 'Sign Up'
        }
      },
      {
        name: 'auth.reg-verify',
        path: 'verify',
        component: () => import('../views/auth/VerifyEmail'),
        meta: {
          title: 'Verify Email'
        }
      },
      {
        name: 'auth.reset',
        path: 'reset',
        component: () => import('../views/auth/Reset'),
        meta: {
          title: 'Reset Password'
        }
      },
      {
        name: 'auth.reset-password',
        path: 'reset-password',
        component: () => import('../views/auth/ResetPassword'),
        meta: {
          title: 'Reset Password'
        }
      }
    ]
  },
  {
    path: '/',
    name: 'cpanel',
    redirect: { name: 'cpanel.dashboard' },
    component: () => import('../layouts/default'),
    meta: {
      middleware: [Authenticated]
    },
    children: [
      {
        name: 'cpanel.dashboard',
        path: 'dashboard',
        component: () => import('../views/cpanel/Dashboard'),
        meta: {
          title: 'Dashboard'
        }
      },
      {
        name: 'cpanel.tours',
        path: 'tours',
        redirect: { name: 'cpanel.tours.list' },
        component: () => import('../layouts/index'),
        children: [
          {
            name: 'cpanel.tours.list',
            path: '/',
            component: () => import('../views/cpanel/tours/index'),
            meta: {
              title: 'My tours'
            }
          },
          {
            name: 'cpanel.tours.scenario',
            path: ':id/scenario',
            component: () => import('../views/cpanel/tours/scenario'),
            meta: {
              title: 'Edit scenes'
            }
          }
        ]
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  // base: process.env.BASE_URL,
  routes
})

middlewarePipeline(router, store)

export default router
